import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';

export const tableMessages = {
  en: {
    noData: 'There is no data to display.',
    itemsTotal: '{count, plural, one {# item} other {# items}} total',
    itemsTotalCapped: 'Showing {cap, number} items of total {count, number}',
    itemsTotalCappedTooltip:
      'Output capped at {cap, number} rows. Try using a filter to see all rows of interest.',
    itemsTotalMore: 'Showing {count, plural, one {# item} other {# items}}',
    itemsTotalMoreTooltip:
      'Total rows not calculated, keep scrolling or use a filter to see all rows of interest.',
    itemsTotalMoreCappedTooltip:
      'Output capped at {cap, number} rows, total not calculated. Try using a filter to see all rows of interest',
    itemsTotalLoading: `Loading${horizontalEllipsis}`,
    actions: {
      autoSizeColumns: 'Auto\xa0size',
      autoSizeColumnsTooltip: (
        <>
          <p>
            <strong>On:</strong> Columns are automatically sized to fit current
            content each time the table is opened.
          </p>
          <p>
            <strong>Off:</strong> Columns respect user defined widths saved
            between sessions.
          </p>
          <p>Tips:</p>
          <ul>
            <li>
              To trigger auto size for data currently in viewport, just turn
              this toggle off and back on.
            </li>
            <li>
              Double click column resize handle to auto size single column.
            </li>
          </ul>
        </>
      ),
      displaySettings: 'Display settings',
      restoreSettings: 'Restore table settings',
    },
    selection: {
      nSelected: '{count} selected',
    },
    settings: {
      title: 'Display Settings',
      columnsVisibilityOrderTitle: 'Column Visibility & Order',
      columnsVisibilityOrderDescription: 'Drag & Drop Column to change order',
    },
    contextMenu: {
      showDetail: 'Show detail',
    },
    rowDetail: {
      title: 'Expanded View',
      noDataAvailable: 'No data available',
    },
  },
};
